import { makeStyles } from '@material-ui/styles'
import React from 'react'
import Input from 'core/elements/input'
import Checkbox from 'core/elements/input/Checkbox'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

interface HostListProps {
  filteredHosts: any[]
  hostSearchQuery: string
  setHostSearchQuery: React.Dispatch<React.SetStateAction<string>>
  selectedHostIds: Set<string>
  handleHostToggle: (hostId: string, checked: boolean) => void
  bundles: any[]
}

const HostList = ({
  filteredHosts,
  hostSearchQuery,
  setHostSearchQuery,
  selectedHostIds,
  handleHostToggle,
  bundles,
}: HostListProps) => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.columnHeader}>
        <Text variant="caption1">Hosts</Text>
      </div>
      <div className={classes.searchContainer}>
        <Input
          placeholder="Search for hosts"
          value={hostSearchQuery}
          onChange={(e) => setHostSearchQuery(e.target.value)}
          icon="search"
          className={classes.searchInput}
        />
      </div>

      <div className={classes.listContainer}>
        {filteredHosts?.length === 0 ? (
          <div className={classes.emptyState}>
            <Text variant="body2">
              {hostSearchQuery
                ? 'No hosts found matching your search.'
                : selectedHostIds?.size === 0
                  ? 'Select clusters or hosts to view them here.'
                  : 'No hosts found in selected clusters.'}
            </Text>
          </div>
        ) : (
          filteredHosts?.map((host) => (
            <div key={host?.id} className={classes.hostItem}>
              <Checkbox
                checked={selectedHostIds?.has(host?.id)}
                onChange={(checked) => handleHostToggle(host?.id, checked)}
                label={<Text variant="body2">{host?.name || host?.id}</Text>}
                disabled={bundles.some((bundle) => bundle.hostIds?.includes(host?.id))}
                info={
                  bundles.some((bundle) => bundle.hostIds?.includes(host?.id))
                    ? 'This host is already in a support bundle.'
                    : ''
                }
              />
            </div>
          ))
        )}
      </div>
    </>
  )
}

export default HostList

const useStyles = makeStyles<Theme>((theme) => ({
  columnHeader: {
    padding: theme.spacing(1.5, 2),
    background: theme.palette.grey[50],
  },
  searchContainer: {
    padding: theme.spacing(0, 2),
  },
  searchInput: {
    width: '100%',
  },
  listContainer: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
  hostItem: {
    borderRadius: 4,
    marginBottom: theme.spacing(0.5),
    '&:hover': {
      background: theme.palette.grey[50],
    },
  },
}))
